import React, { useState } from 'react'
import {
  faCapsules,
  faDna,
  faFlask,
  faGlobe,
  faIndustry,
  faMicrochip,
  faPills,
  faSprayCan,
  faSyringe,
  faVial,
} from '@fortawesome/free-solid-svg-icons'
import Input from '../../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import { SelectMulti } from '../../../../../../../../Components/CustomUi/SelectMulti'
import TextArea from '../../../../../../../../Components/CustomUi/textarea'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { apenasNumerosDecimais } from '../../../../../../../../utils'

interface PropsDados {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacao_id: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricante_id: React.Dispatch<React.SetStateAction<number>>
  tecnologia: string
  setTecnologia: React.Dispatch<React.SetStateAction<string>>
  setTecnologia_id: React.Dispatch<React.SetStateAction<number>>
  dose_padrao_hectare: string
  setDose_padrao_hectare: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  origem_selecionada: string
  setOrigem_selecionada: React.Dispatch<React.SetStateAction<string>>
  setOrigem_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  tipo_biologico_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_biologico_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  tipo_aplicacao_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_aplicacao_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  data_biológicos: any[]
  data_formulação: any[]
  data_aplicação: any[]
  data_tecnologia: any[]
  data_fabricante: any[]
}

export const FormDados: React.FC<PropsDados> = ({
  nome,
  setNome,
  dose_padrao_hectare,
  setDose_padrao_hectare,
  formulacao,
  setFormulacao,
  setFormulacao_id,
  fabricante,
  setFabricante,
  setFabricante_id,
  tecnologia,
  setTecnologia,
  setTecnologia_id,
  observacao,
  setObservacao,
  origem_selecionada,
  setOrigem_selecionada,
  setOrigem_selecionada_id,
  tipo_aplicacao_selecionadas,
  setTipo_aplicacao_selecionadas,
  tipo_biologico_selecionadas,
  setTipo_biologico_selecionadas,
  data_aplicação,
  data_biológicos,
  data_formulação,
  data_tecnologia,
  data_fabricante,
}) => {
  const [openOrigem, setOpenOrigem] = useState<boolean>(false)
  const [openBiologico, setOpenBiologico] = useState<boolean>(false)
  const [openFormulacao, setOpenFormulacao] = useState<boolean>(false)
  const [openAplicacao, setOpenAplicacao] = useState<boolean>(false)
  const [openTecnologia, setOpenTecnologia] = useState<boolean>(false)
  const [openFabricante, setOpenFabricante] = useState<boolean>(false)

  const getUnidadeMedida = (formulacao: string) => {
    if (['Líquida', 'Gel'].includes(formulacao)) {
      return 'L/ha'
    }
    if (['Turfosa', 'Liofilizada', 'Sólido'].includes(formulacao)) {
      return 'kg/ha'
    }
    return ''
  }

  const dataOrigem = [
    { cod: 1, nome: 'Comercial' },
    { cod: 2, nome: 'OnFarm' },
    { cod: 3, nome: 'Comercial OnFarm' },
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Input
        label='Nome'
        icon={faVial}
        placeholder='Digite o nome do produto'
        value={nome}
        onChange={setNome}
      />
      <Select
        label='Origem'
        placeholder='Selecione a origem'
        icon={faGlobe}
        open={openOrigem}
        trigger={setOpenOrigem}
        items={dataOrigem}
        descricaoItem={'nome'}
        idItem={'cod'}
        value={origem_selecionada}
        onChange={setOrigem_selecionada}
        onChangeID={setOrigem_selecionada_id}
      />
      <Render condition={origem_selecionada !== 'OnFarm'}>
        <Select
          icon={faIndustry}
          label='Fabricante'
          placeholder='Digite o fabricante'
          value={fabricante}
          onChange={setFabricante}
          onChangeID={setFabricante_id}
          open={openFabricante}
          trigger={setOpenFabricante}
          items={data_fabricante}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
      </Render>

      <SelectMulti
        label='Tipo de biológicos'
        placeholder='Selecione os tipos de biológicos'
        icon={faDna}
        open={openBiologico}
        trigger={setOpenBiologico}
        items={data_biológicos}
        descricaoItem={'nome'}
        idItem={'cod'}
        selecteds={tipo_biologico_selecionadas}
        onChange={setTipo_biologico_selecionadas}
      />
      <Select
        label='Formulação'
        placeholder='Selecione a formulação'
        icon={faFlask}
        value={formulacao}
        onChange={setFormulacao}
        onChangeID={setFormulacao_id}
        open={openFormulacao}
        trigger={setOpenFormulacao}
        items={data_formulação}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
      <SelectMulti
        label='Aplicação'
        placeholder='Selecione os tipos de aplicação'
        icon={faSprayCan}
        open={openAplicacao}
        trigger={setOpenAplicacao}
        items={data_aplicação}
        descricaoItem={'nome'}
        idItem={'cod'}
        selecteds={tipo_aplicacao_selecionadas}
        onChange={setTipo_aplicacao_selecionadas}
      />
      <Select
        label='Tecnologia'
        placeholder='Selecione a tecnologia'
        icon={faMicrochip}
        value={tecnologia}
        onChange={setTecnologia}
        onChangeID={setTecnologia_id}
        open={openTecnologia}
        trigger={setOpenTecnologia}
        items={data_tecnologia}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
      <Input
        label={`Dose padrão por hectáre ${getUnidadeMedida(formulacao) ? `(${getUnidadeMedida(formulacao)})` : ''}`}
        placeholder='Digite a dose padrão por hectáre'
        icon={faCapsules}
        value={apenasNumerosDecimais(dose_padrao_hectare)}
        onChange={setDose_padrao_hectare}
      />
      <TextArea label='Observação' value={observacao} onChange={setObservacao} />
    </div>
  )
}
